module.exports = __webpack_public_path__ + "img/check.1274b025.svg";